import type { ApiError } from '@berytus/contracts';

export class HttpError extends Error {
  constructor(public status: number, message: string, public code?: string, public field?: string) {
    super(message);
  }
}

/** Chama a API com o cookie de sessão. Erros viram HttpError com a mensagem da API. */
export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, headers, ...rest } = init;
  const res = await fetch(`/api/v1${path}`, {
    credentials: 'same-origin',
    ...rest,
    headers: { ...(json !== undefined ? { 'content-type': 'application/json' } : {}), ...headers },
    body: json !== undefined ? JSON.stringify(json) : rest.body,
  });
  if (!res.ok) {
    let body: Partial<ApiError> & { field?: string } = {};
    try {
      body = await res.json();
    } catch {
      /* resposta sem JSON */
    }
    throw new HttpError(res.status, body.message ?? `Erro ${res.status}`, body.error, body.field);
  }
  return res.status === 204 ? (undefined as T) : ((await res.json()) as T);
}

export const brl = (v: string | number | null | undefined) =>
  v == null || v === '' ? '—' : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const int = (v: number) => v.toLocaleString('pt-BR');

export const pct = (v: string | number | null | undefined) =>
  v == null ? '—' : `${(Number(v) * 100).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;

/** Data e hora no formato brasileiro (dd/mm/aaaa hh:mm), no horário de Brasília. */
export const dateTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Sao_Paulo' }).replace(',', '') : '—';
